import { render } from "./BarChart.vue?vue&type=template&id=5b354be0&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=5b354be0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b354be0"

export default script